import * as styles from "./PopoverContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import type { PopoverContentProps } from "./Popover.types";
import { PopoverArrow } from "./PopoverArrow";
import { PopoverPortal } from "./PopoverPortal";

export function PopoverContent({
  className,
  children,
  anchor,
  side = "bottom",
  sideOffset = 8,
  align = "center",
  alignOffset = 0,
  positionMethod,
  disableAnchorTracking,
  collisionAvoidance,
  arrow = true,
  ...props
}: PopoverContentProps): JSX.Element {
  return (
    <PopoverPortal>
      <BasePopover.Positioner
        data-slot="popover-positioner"
        className={styles.positioner}
        anchor={anchor}
        side={side}
        sideOffset={sideOffset}
        align={align}
        alignOffset={alignOffset}
        positionMethod={positionMethod}
        disableAnchorTracking={disableAnchorTracking}
        collisionAvoidance={collisionAvoidance}
      >
        <BasePopover.Popup
          data-slot="popover-content"
          className={clsx(styles.popup, className)}
          {...props}
        >
          {children}
          {arrow && <PopoverArrow />}
        </BasePopover.Popup>
      </BasePopover.Positioner>
    </PopoverPortal>
  );
}
